import { NavLink, RouteObject, useNavigate } from "react-router";

import { checkTabIsActive, PageHeading, Tabs } from "@prequel/shared-components";

import ModelPage from "./ModelPage";
import ModelsTable from "./ModelsTable";
import ProductForm from "./ProductForm";
import ProductPage, { ProductDetailsPage, ProductEditPage } from "./ProductPage";
import ProductsTable from "./ProductsTable";

import Breadcrumbs from "@/components/Breadcrumbs";

const tabs = [
  <NavLink key="Models" to="/models" className={checkTabIsActive} replace end>
    Models
  </NavLink>,
  <NavLink key="Products" to="/models/products" className={checkTabIsActive} replace end>
    Products
  </NavLink>,
];

const ModelsListLayout = () => {
  return (
    <div className="h-full flex-col">
      <div className="max-w-6xl px-7 py-4 pb-16">
        <PageHeading title="Models & Products" />
        <Tabs tabs={tabs} />
        <ModelsTable />
      </div>
    </div>
  );
};

const ProductsListLayout = () => {
  return (
    <div className="h-full flex-col">
      <div className="max-w-6xl px-7 py-4 pb-16">
        <PageHeading title="Models & Products" />
        <Tabs tabs={tabs} />
        <ProductsTable />
      </div>
    </div>
  );
};

const ProductFormNewLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full flex-col">
      <div className="max-w-xl px-7 py-4">
        <PageHeading title="Add Product" onGoBack={() => navigate("/models/products")} breadcrumbs={<Breadcrumbs />} />
        <ProductForm />
      </div>
    </div>
  );
};

export const modelsRoutes: RouteObject = {
  path: "models",
  handle: {
    breadcrumb: () => ({ label: "Models & Products" }),
  },
  children: [
    {
      index: true,
      element: <ModelsListLayout />,
    },
    {
      path: "products",
      element: <ProductsListLayout />,
    },
    {
      path: ":modelID",
      handle: {
        breadcrumb: (params) => ({
          label: "Model Details",
          id: params?.modelID,
        }),
      },
      element: <ModelPage />,
    },
    {
      path: "products/new",
      handle: {
        breadcrumb: () => ({ label: "Add Product" }),
      },
      element: <ProductFormNewLayout />,
    },
    {
      path: "products/:productID",
      handle: {
        breadcrumb: (params) => ({
          label: "Product Details",
          id: params?.productID,
          dynamic: true,
        }),
      },
      element: <ProductPage />,
      children: [
        {
          index: true,
          element: <ProductDetailsPage />,
        },
        {
          path: "edit",
          handle: {
            breadcrumb: (params) => ({
              label: "Edit Product",
              id: params?.productID,
            }),
          },
          element: <ProductEditPage />,
        },
      ],
    },
  ],
};
